publishingApp.controller('RootCtrl', ['$rootScope', '$uibModal', 'dbData', '$state', '$cookies', '$location', '$window', '$http', '$stateParams', '$timeout', '$scope', '$log', 'exceptionHandler', '$q', function ($rootScope, $uibModal, dbData, $state, $cookies, $location, $window, $http, $stateParams, $timeout, $scope, $log, exceptionHandler, $q) {
    $rootScope.env = document.getElementById('main-doc').dataset.env;
    $rootScope.pubHubUrl = document.querySelector('body').dataset.pubHubUrl;
    $rootScope.year = new Date().getFullYear();
    $rootScope.absUrl = window.location.protocol + '//' + $location.host() + '/';
    $rootScope.alerts = [];
    $rootScope.apiUrl = $rootScope.absUrl;
    $rootScope.user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;

    $rootScope.treeValidationError = null;
    $rootScope.masterTreeValidationError = null;

    $rootScope.currentPublisher = null;
    $rootScope.availablePublishers = null;

    $('body').on('click', '.accordion--trigger', function () {
        $(this).closest('.accordion').toggleClass('active');
        $(this).parent().find('.accordion--body').slideToggle();
    });

    $rootScope.reviewVersion = 0;

    $rootScope.courseImport = {
        "type": "",
        "file": {},
        "import_slide_notes": false,
        "header_tag": "<h1>",
    };

    /**
     * Items required to happen on every state change
     */
    $rootScope.$on('$stateChangeStart',
        function (event, toState, toParams, fromState, fromParams) {
            // We should know course status_id, maths toggle, validation toggle, feedback toggle on all course related screens that might not have them
            var settings_inclusions = ['editor', 'editor-question', 'assessment', 'course-assessment'];
            if (settings_inclusions.indexOf(toState.name) !== -1) {
                const LOCKED = [2, 3, 6, 7];   // 5 removed even though is locked

                dbData.get('courses/' + toParams.id).then(function (response) {
                    if (response.data.status_id) {
                        $rootScope.status_id = response.data.status_id;

                        // If the course is locked, redirect to Index
                        if (LOCKED.includes(response.data.status_id) && !$rootScope.userCan($rootScope.user.permissions, ['course-publish'])) {
                            $rootScope.pushAlerts("Sorry, you have no permission to access this");
                            $state.go('index');
                        }
                    }

                    if (response.data.assets) {
                        $rootScope.assets = JSON.parse(response.data.assets);
                    }

                    if (response.data.validation_enabled) {
                        $rootScope.validation_enabled = response.data.validation_enabled;
                    }

                    if (response.data.feedback_enabled) {
                        $rootScope.feedback_enabled = (response.data.feedback_enabled) ? true : false;
                    }

                    if (response.data.feedback_enabled) {
                        dbData.get('api/courses/' + toParams.id + '/feedback').then(
                            function (response) {
                                $rootScope.reviewVersion = Object.keys(response.data).length;
                                $rootScope.finalReviews = response.data;
                                $rootScope.$broadcast('reviews-data-saved');

                                $('.page-loading').addClass('hidden');

                                console.log('feedback in the root controller');

                            }, function (error) {
                                $log.error(error);
                                $('.page-loading').addClass('hidden');
                            }
                        );
                    }

                    $rootScope.primaryCipCode = response.data.primary_cip_code;
                    $rootScope.secondaryCipCode = response.data.secondary_cip_code;

                    console.info("assets", $rootScope.assets, "validation", $rootScope.validation_enabled, "feeback", $rootScope.feedback_enabled, "status", $rootScope.status_id, "review version", $rootScope.reviewVersion);

                }, function (error) {
                    $log.error(error);
                });
            }

            // Publishers - need to time out for user to properly resolve, otherwise null returned
            var publisher_exclusions = ['course-preview', 'course-modules', 'course-player', 'course-resources', 'logout', 'home', 'no-permission'];

            if (!(publisher_exclusions.indexOf(toState.name) !== -1)) {
                setTimeout(function () {

                    if (!$rootScope.availablePublishers && $rootScope.user != null) {
                        // Get list of available Publishers
                        dbData.get("api/users/" + $rootScope.user.id + "/publishers").then(
                            function (response) {
                                $rootScope.availablePublishers = null;
                                $rootScope.availablePublishers = response.data;
                            },
                            function (error) {
                                $log.error("Error - cannot fetch users associated publishers: " + error.message);
                            }
                        );
                    }

                    if (!$rootScope.currentPublisher && $rootScope.user != null) {
                        // Get current Publisher name
                        dbData.get("api/publishers/" + $rootScope.user.publisher_id).then(
                            function (response) {
                                $rootScope.currentPublisher = response.data;
                            },
                            function (error) {
                                $log.error("Error - cannot fetch publisher: " + error.message);
                                // Switch to default publisher
                                changePublisher($rootScope.availablePublishers[0].id);
                            }
                        );
                    }

                }, 3000);


            }
        }
    );

    // Variables
    $rootScope.isOpen = false;
    $rootScope.newCourseStepOne = false;

    $rootScope.ignoreSoftErrors = false;

    $rootScope.summaryOptions = {
        plugins: 'paste',
        toolbar: 'bold italic | superscript subscript | ',
        paste_as_text: true
    };

    $rootScope.outcomesOptions = {
        plugins: 'paste lists',
        toolbar: 'bold italic | superscript subscript | bullist',
        paste_as_text: true
    };

    $rootScope.showGallery = false;
    $rootScope.showAudio = false;

    // Preview Export related variables
    $rootScope.disabled = false;
    $rootScope.exportReady = false;
    $rootScope.export_id = null;
    $rootScope.exportState = null;
    $rootScope.executionEnded = null;

    //$rootScope.allAssets = ['heading', 'paragraph', 'image','list', 'divider', 'video','audio', 'language', 'vertical tabs','modal', 'accordion', 'horizontal tabs','table', 'maths'];
    // Above is for future exploits
    $rootScope.allAssets = ['maths'];

    $rootScope.actionVerbs = [];

    // $rootScope.emailFormat = /^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,5}$/;

    // Variable for Questions/Pages filtering in the Editor Sidebar
    $rootScope.searchBy = [];
    $rootScope.searchBy.text = localStorage.getItem('query') ? localStorage.getItem('query') : '';

    // FUNCTIONS

    /**
     * Check if user can perform an action
     * @param usersPermissions {array} is the list of users permission
     * @param permissionsRequired {array} is the list of permissions required to perform an action
     * @param permissionsForbidden {array=} is the list of permissions denied to perform an action (cases where we want single role to be able to see a button or something)
     * @returns {boolean}
     */
    $rootScope.userCan = function (usersPermissions, permissionsRequired, permissionsForbidden) {
        var permissionsForbidden = permissionsForbidden || [];

        var result = true;
        for (var i = 0; i < permissionsRequired.length; i++) {
            if (!usersPermissions.includes(permissionsRequired[i])) {
                result = false;
                break;
            }
        }

        if (result && permissionsForbidden.length > 0) {
            for (var i = 0; i < permissionsForbidden.length; i++) {
                if (usersPermissions.includes(permissionsForbidden[i])) {
                    result = false;
                    break;
                }
            }
        }
        return result;
    };

    $rootScope.rawOutcomes = function (course) {
        if (Array.isArray(course.outcomes)) {
            return course.outcomes.join(';\n');
        }
        else {
            return course.outcomes;
        }
    };

    $rootScope.buildOutcomes = function (course) {
        var outcomes = course.outcomes ? course.outcomes : '';
        outcomes = outcomes.replace(/\n/g, '');
        return outcomes.split(';');
    };

    // sidebar search box on blur event
    $rootScope.onBlur = function () {
        localStorage.setItem('query', $rootScope.searchBy.text);
    };

    var changePublisher = function (newPublisherId) {
        var request = {
            method: 'GET',
            url: 'login-with-another-publisher/' + newPublisherId,
        };

        $http(request).then(
            function (response) {
                $rootScope.pushAlerts("Publisher changed successfully");
                $window.location.href = "/";
            }, function (error) {
                $rootScope.pushAlerts("Error changing the publisher: " + error);
            }
        );
    };

    // Variables when creating new course
    $rootScope.name = null;
    $rootScope.headline = null;
    $rootScope.short_summary = null;
    $rootScope.summary = null;
    $rootScope.outcomes = null;
    $rootScope.style_id = null;
    $rootScope.bugReport = null;
    $rootScope.language_id = null;
    $rootScope.content_rights_id = null;
    $rootScope.meta_title = null;
    $rootScope.meta_desc = null;
    $rootScope.keywords = null;
    $rootScope.validation_enabled = true;
    $rootScope.feedback_enabled = true;

    // Navigate to last accessed course
    $rootScope.manageCurrentCourse = function () {
        window.location.href = document.querySelector('body').dataset.pubHubUrl + '/course-structure/course/' + $rootScope.currentCourse;
    };

    // Logout.
    $rootScope.logout = function () {
        localStorage.clear();
        $state.go('logout');
    };

    // Toggle Sidebar open/ close
    $rootScope.showFAQMenu = function () {
        $('.sidebar__faqs-label').toggleClass('current');
        $('.sidebar__faqs-links').slideToggle();
    };

    // Toggle Sidebar open/ close
    $rootScope.sidebarOpen = function () {
        $rootScope.isOpen = !$rootScope.isOpen;
    };


    // Alert notification
    $rootScope.pushAlerts = function (message, disposable, validationError, contentError, icon, background, type) {
        var disposable = disposable || null,
            validationError = validationError || null,
            contentError = contentError || null,
            icon = icon || null,
            background = background || null;
        type = type || null;

        //same alert was pushed, ignore
        if ($rootScope.alerts.filter(function (alert) {
            return alert.type === type && type !== null;
        }).length > 0) {
            return;
        }

        $rootScope.alerts.push({
            message: message,
            disposable: disposable,
            validationError: !!(validationError && (message.strictErrors != null || message.softErrors != null) && (!jQuery.isEmptyObject(message.strictErrors) || !jQuery.isEmptyObject(message.softErrors))),
            icon: icon,
            background: background,
            contentError: contentError,
            type: type
        });

        $timeout(function () {
            angular.forEach($rootScope.alerts, function (value, key) {
                if (!value.disposable) {
                    $rootScope.alerts.splice(key, 1);
                }
            });
        }, 5000);
    };

    // Discards current alert if is disposable
    $rootScope.discardAlert = function (alert) {
        angular.forEach($rootScope.alerts, function (value, key) {
            if (value.message == alert.message) {
                $rootScope.alerts.splice(key, 1);
            }
        });
    };

    // Remove all discardable alerts
    $rootScope.discardAlerts = function (delay) {
        // to have delay 0, put negative number in
        var delay = (delay < 0) ? 0 : delay || 3000;

        setTimeout(function () {
            $.each($rootScope.alerts, function (i, v) {
                if (v.disposable) {
                    $rootScope.alerts.splice(i, 1);
                }
            });

            $rootScope.$digest();
        }, delay);
    };

    // Get list of action verbs for learning outcomes
    $rootScope.getActionVerbs = function () {
        if ($rootScope.actionVerbs.length > 0) {
            $rootScope.actionVerbs = [];
        } else {
            dbData.get('api/approved-learning-outcomes').then(function (response) {
                $rootScope.actionVerbs = response.data;
                if ($rootScope.language_id) {
                    $rootScope.actionVerbs = $rootScope.actionVerbs.filter(function (verbs) {
                        // by default use US English
                        var languageNeeded = 44;
                        // if selected languages is in Spanish language group, use Spanish instead
                        if ([138, 139, 140, 141].indexOf($rootScope.language_id) !== -1) {
                            languageNeeded = 138;
                        }
                        // if selected languages UK English, use it instead
                        if ($rootScope.language_id === 43) {
                            languageNeeded = $rootScope.language_id;
                        }
                        return verbs.language_id === languageNeeded;
                    });
                }
            }, function (error) {
                $log.error(error);
            });
        }
    };

    $rootScope.$on('$destroy', function () {
        $('body').off('change', 'select.change_publisher');
    });
    $('body').on('change', 'select.change_publisher', function () {
        var targetId = ($(this).find(":selected").data("value"));
        if (typeof targetId !== "undefined") {
            changePublisher(targetId);
        }

        // revert select options back to the default
        $(this).find(":nth-child(1)").prop('selected', true);
    });

    // Retrieve Content Rights and Languages for dropdowns in the Front End
    $rootScope.getLanguagesAndContentRights = function () {
        dbData.get('get-languages-and-content-rights').then(function (response) {
            $rootScope.dropdowns = response.data;
        }, function (error) {
            // $scope.pushAlerts('Unable to retrieve courses at this moment.');
        });
    };

    $rootScope.createNewCourse = function () {
        var pubhubNewServer = document.getElementById("main-doc").dataset.pub_hub_url;
        window.location.href = pubhubNewServer + '/course/creation';
    };

    $rootScope.editCourse = function (course) {
        var pubhubNewServer = document.getElementById("main-doc").dataset.pub_hub_url;
        window.location.href = pubhubNewServer + '/course/edit?courseId=' + course.id;
    };

    $rootScope.toggleDormant = function (course_id, state) {
        var data = {
            'id': course_id,
            'dormant': (state) ? 1 : 0,
        };

        dbData.post('course-dormant', data).then(function () {
            angular.forEach($rootScope.currentCourses, function (item, key) {
                if (item.id == data.id) {
                    item.dormant = data.dormant;
                }
            });
        }, function (error) {
        });
    };


    /***** UTILITIES *****/

    /**
     * Test type of the provided argument
     *
     * @param input
     * @returns {"undefined"|"object"|"boolean"|"number"|"string"|"function"|"symbol"|"bigint"}
     */
    $rootScope.testTypeOf = function (input) {
        return typeof (input);
    };

    /**
     * Checks array of objects for a presence of an object with given property and value and removes it from that array
     *
     * @param target
     * @param property
     * @param value
     */
    $rootScope.removeFromScope = function (target, property, value) {
        return $.grep(target, function (element, index) {
            return element[property] == value
        }, true);
    };

    /**
     * Redirect to the given state
     *
     * @param state
     */
    $rootScope.redirect = function (state) {
        $state.go(state);
    };

    $rootScope.disableEnterKeyPressHandler = function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            e.stopPropagation();
        }
    };

    /**
     * Get Object from array based on property - value pair
     * 
     * @param {array} source to be filtered
     * @param {string} property
     * @param {any} value
     * @returns {object}
     */
    $rootScope.getObjectByPropertyValue = function (source, property, value) {
        return source.filter(function (obj) {
            if (obj[property] == value) {
                return obj;
            }
        })[0];
    }
}]);

